/**
 * The wild boar — the animal that is the exact inverse of the stag (M2-05).
 *
 * Easy to find, easy to reach, and the single most dangerous thing in the
 * commote once you have. Where a stag's defence is distance, a boar's is a
 * shield of gristle over its chest and shoulders and a total absence of any
 * instinct to run. It is low, so its tusks arrive at knee height; it is heavy,
 * so being hit by it is being hit by half a ton.
 *
 * This is Ysgithyrwyn's plan in miniature (M5). What the MVP has to prove here
 * is the shape of the fight the Great Hunt will be: the hide makes a swing at
 * the body nearly pointless, and the head and the legs are what a hunter has
 * to be willing to aim at — which is M2-03's aimed blows earning their keep.
 */
import { quadruped } from './quadruped.js';
export const BOAR_PLAN = quadruped({
    id: 'boar',
    name: 'boar',
    foreleg: 'shoulder',
    hindleg: 'ham',
    foot: 'trotter',
    // Everything about a boar is front-loaded: it fights by driving forwards,
    // and the shoulders are what it presents while doing it.
    foreWeight: 1.8,
    skull: 0.8,
    extras: [
        {
            id: 'tusk.left',
            zone: 'head',
            side: 'left',
            name: 'near tusk',
            hitWeight: 0.5,
            contributes: {},
            contains: ['bone'],
        },
        {
            id: 'tusk.right',
            zone: 'head',
            side: 'right',
            name: 'off tusk',
            hitWeight: 0.5,
            contributes: {},
            contains: ['bone'],
        },
    ],
});
//# sourceMappingURL=boar.js.map